import { useCallback, useState } from "react";

export const useFavoriteSavedTooltip = () => {
    const [isSavedOpen, setIsSavedOpen] = useState<boolean>(false);

    const openSaved = useCallback(() => {
        setIsSavedOpen(true);
    }, []);

    const closeSaved = useCallback(() => {
        setIsSavedOpen(false);
    }, []);

    return {
        isSavedOpen,
        openSaved,
        closeSaved,
    };
};
